import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChooseTopologyItemContextMenuService {

  constructor() { }

  prepareContextMenuActions(diagramApi, clickedElement): any {
    let actionsObject;
    const diagramElement = clickedElement;

    const updateActionsSupport = () => {
      if (!diagramElement) {
        return;
      }

      if (diagramElement.shapeType === 'node') {
        if (diagramElement.dataItem.productType !== 'THIRD_PARTY') {
          actionsObject.currentElement = 'node';
        } else {
          actionsObject.currentElement = 'thirdPartyNode';
        }
      } else if (diagramElement.shapeType === 'voipPeer') {
        actionsObject.currentElement = 'voipPeer';
      } else if (diagramElement.shapeType === 'cluster') {
        actionsObject.currentElement = 'cluster';
      } else if (diagramElement.connectionType === 'connection') {
        actionsObject.currentElement = 'connection';
      } else if (diagramElement.connectionType === 'peerConnection') {
        if (diagramElement.dataItem.peerConnectionNodeType === 'Virtual') {
          actionsObject.currentElement = 'virtualPCon';
        } else {
          actionsObject.currentElement = 'peerConnection';
        }
      } else if (diagramElement.connectionType === 'cluster') {
        actionsObject.currentElement = 'edgesCluster';
      }
    };

    // actions

    function expandNode(): any {
      diagramApi.openCluster(diagramElement.id);
    }

    actionsObject = {
      currentElement: 'node',
      node: [],
      thirdPartyNode: [],
      voipPeer: [],
      connection: [],
      peerConnection: [],
      virtualPCon: [],
      edgesCluster: [],
      cluster: [
        {actionName: 'expandNode', click: expandNode,
          visible: true,
          html: '<div class="diagram-context-menu-item">' +
            '<div class="diagram-action-icon">' +
            '<i class="fa fa-expand fa-lg"></i>' +
            '</div>' +
            '<span>Expand</span></div>'}
      ]
    };

    updateActionsSupport();

    return actionsObject[actionsObject.currentElement];
  }
}
